import Constant from '@/const';
import axios from 'axios';

const postAssessmentPcare = async idRegistration => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/patient/reassessment/pcare/${idRegistration}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default postAssessmentPcare;
